document.addEventListener("DOMContentLoaded", function() {
    function updateStockMessage() {
            console.log('Variant changed, updating stock message.');
        var variantSelect = document.querySelector('[name="id"]');
        var stockMessage = document.querySelector(".stock-message");

        if (!variantSelect || !stockMessage) return; // Exit if elements are not found

        var selectedOption = variantSelect.options[variantSelect.selectedIndex];
        var variantId = selectedOption.value;
        var variantsData = JSON.parse(document.querySelector('[data-variants-json]').textContent);

        var currentVariant = variantsData.find(variant => variant.id == variantId);

        if (currentVariant && currentVariant.inventory_management) {
            var inventory = currentVariant.inventory_quantity;

            if (inventory > 0 && inventory <= 5) {
                stockMessage.innerHTML = "Only " + inventory + " left in stock!";
                stockMessage.className = "low-stock-message";
            } else if (inventory > 5) {
                stockMessage.innerHTML = "In Stock: " + inventory + " available";
                stockMessage.className = "in-stock-message";
            } else {
                stockMessage.innerHTML = "Out of stock";
                stockMessage.className = "out-of-stock-message";
            }
        }
    }

    document.addEventListener("change", function(event) {
        if (event.target && event.target.name === "id") {
            updateStockMessage();
        }
    });

    // Initial load
    updateStockMessage();
});
